<template>
  <div class="fill-condition flex flex-1">
    <el-select class="ml-3" v-model="condition" size="small" placeholder="请选择">
      <el-option v-for="item in conditions" :key="item.value" :value="item.value" :label="item.label" />
    </el-select>
    <template v-if="hasInput">
      <el-input v-model="value" size="small" class="flex-1 ml-3" placeholder="请输入" />
    </template>
  </div>
</template>

<script>
import { INCLUDED, NOT_INCLUDED, EQ, NOT_EQ, NULL, NOT_NULL } from '@/assets/js/config/condition-config'

export default {
  name: 'FillCondition',
  data() {
    return {
      conditions: [
        {
          label: '包含',
          value: INCLUDED
        },
        {
          label: '不包含',
          value: NOT_INCLUDED
        },
        {
          label: '等于',
          value: EQ
        },
        {
          label: '不等于',
          value: NOT_EQ
        },
        {
          label: '为空',
          value: NULL
        },
        {
          label: '不为空',
          value: NOT_NULL
        }
      ],
      value: ''
    }
  },
  created() {
    this.condition = INCLUDED
  },
  methods: {
    getParam() {
      if (!this.value) {
        throw new Error(`${this.data.optionName}请填写要搜索的值`)
      }
      return [this.value]
    },
    getShowText() {
      let label = this.conditions.find(c => c.value === this.condition).label
      return `${this.data.optionName} ${label}${this.value ? ' ' + this.value : ''}`
    }
  },
  computed: {}
}
</script>

<style scoped></style>
